var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "decorative-divider" }),
    _vm._v(" "),
    _vm.bankAccountDetails
      ? _c("div", { staticClass: "bank-details" }, [
          _c("h2", [_vm._v("Payment details")]),
          _vm._v(" "),
          _vm.bankAccountDetails["Bank Name"]
            ? _c("p", [
                _c("strong", [_vm._v("Bank Name:")]),
                _vm._v(" " + _vm._s(_vm.bankAccountDetails["Bank Name"])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.bankAccountDetails["Account Name"]
            ? _c("p", [
                _c("strong", [_vm._v("Account Name:")]),
                _vm._v(" " + _vm._s(_vm.bankAccountDetails["Account Name"])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.bankAccountDetails["BSB"]
            ? _c("p", [
                _c("strong", [_vm._v("BSB:")]),
                _vm._v(" " + _vm._s(_vm.bankAccountDetails["BSB"])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.bankAccountDetails["IBAN"]
            ? _c("p", [
                _c("strong", [_vm._v("IBAN:")]),
                _vm._v(" " + _vm._s(_vm.bankAccountDetails["IBAN"])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.bankAccountDetails["Account Number"]
            ? _c("p", [
                _c("strong", [_vm._v("Account Number:")]),
                _vm._v(" " + _vm._s(_vm.bankAccountDetails["Account Number"])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.bankAccountDetails["SWIFT"]
            ? _c("p", [
                _c("strong", [_vm._v("SWIFT/BIC:")]),
                _vm._v(" " + _vm._s(_vm.bankAccountDetails["SWIFT"])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.bankAccountDetails["Bank Address"]
            ? _c("p", [
                _c("strong", [_vm._v("Bank Address:")]),
                _vm._v(" " + _vm._s(_vm.bankAccountDetails["Bank Address"])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("Reference:")]),
            _vm._v(" PS" + _vm._s(_vm._f("padded")(_vm.booking.id, "0", 5))),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _vm.selectedPaymentAmountsAreNotSent
          ? _c(
              "ladda-button",
              {
                staticClass: "btn btn-payment",
                attrs: { type: "submit", click: _vm.handlePaymentSentCallback },
              },
              [
                _c("i", { staticClass: "fa fa-send" }),
                _vm._v(" Payment Sent\n    "),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.$userIsAdmin
      ? _c("ul", { staticClass: "large-checklist" }, [
          _c("li", [
            _c("div", { staticClass: "checkbox checkbox-primary" }, [
              _c("input", {
                attrs: {
                  type: "checkbox",
                  id: "checkbox_payment_received",
                  disabled: _vm.processingPaymentsReceived,
                },
                on: { click: _vm.handlePaymentReceivedCallback },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "checkbox_payment_received" } }, [
                _vm._v("\n          Payment Received\n        "),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }